import { SxStyleProp } from 'theme-ui';

export const Container: SxStyleProp = {
  maxWidth: '943px',
  textAlign: 'center',
  marginX: 'auto',
};

export const PostTitle: SxStyleProp = {
  color: 'indigo.100',
  marginBottom: '7px',
  maxWidth: ['317px', '948px'],
  marginX: 'auto',
};

export const PostDate: SxStyleProp = {
  textTransform: 'uppercase',
  color: 'indigo.100',
};

export const AuthorBox: SxStyleProp = {
  color: 'indigo.100',
  marginTop: '23px',
};

export const AuthorImg: SxStyleProp = {
  marginBottom: '19px',
  marginX: 'auto',
};

export const AuthorName: SxStyleProp = {
  color: 'indigo.100',
  marginBottom: '3px',
};

export const AuthorHeadline: SxStyleProp = {
  color: 'indigo.100',
};
